import { api } from '../index';
import {
  SignedContractResponse,
  ContractResponse,
  SendContractRequest,
} from '@/core/typings/globals';

const BASE_CONTRACTS_API_URL = 'api/contracts';
const BASE_SIGNED_CONTRACTS_API_URL = 'api/signed-contracts';

async function getSignedContracts(
  page?: number,
  status?: string,
  q?: string,
  product?: number,
  startDate?: Date | null,
  endDate?: Date | null
): Promise<PaginatedResponse<SignedContractResponse>> {
  let url = `${BASE_SIGNED_CONTRACTS_API_URL}?page=${page}`;
  if (q) url += `&q=${encodeURIComponent(q)}`;
  if (product) url += `&product=${encodeURIComponent(product)}`;
  if (status) url += `&status=${encodeURIComponent(status)}`;
  if (startDate) {
    url += `&date_from=${startDate.toISOString()}`;
  }
  if (endDate) {
    url += `&date_to=${endDate.toISOString()}`;
  }

  const result = await api.get<PaginatedResponse<SignedContractResponse>>(url);
  return result.data;
}

async function updateSignedContract(
  signedContract: SignedContractResponse
): Promise<SignedContractResponse> {
  const result = await api.put(
    `${BASE_SIGNED_CONTRACTS_API_URL}/${signedContract.id}`,
    signedContract
  );
  return result.data;
}

async function uploadSignedContract(
  signedContract: SignedContractResponse
): Promise<SignedContractResponse> {
  const payload = {
    document: signedContract.document,
  };
  const result = await api.put(
    `${BASE_SIGNED_CONTRACTS_API_URL}/${signedContract.id}/upload_signed`,
    payload
  );
  return result.data;
}

async function resendSignedContract(
  signedContractId: number
): Promise<SignedContractResponse> {
  const result = await api.post(
    `${BASE_SIGNED_CONTRACTS_API_URL}/${signedContractId}/resend`
  );
  return result.data;
}

async function deleteSignedContract(signedContractId): Promise<void> {
  return await api.delete(
    `${BASE_SIGNED_CONTRACTS_API_URL}/${signedContractId}`
  );
}

async function getContracts(
  page?: number,
  q?: string
): Promise<PaginatedResponse<ContractResponse>> {
  const result = await api.get<PaginatedResponse<ContractResponse>>(
    BASE_CONTRACTS_API_URL,
    { params: { page, q } }
  );
  return result.data;
}

async function getContract(contractId: number): Promise<ContractResponse> {
  const result = await api.get<ContractResponse>(
    `${BASE_CONTRACTS_API_URL}/${contractId}`
  );
  return result.data;
}

async function getAllContracts(q?: string): Promise<ContractResponse[]> {
  const url = `${BASE_CONTRACTS_API_URL}/all`;
  const result = await api.get<ContractResponse[]>(url, { params: { q } });
  return result.data;
}

async function createContract(
  contract: ContractResponse
): Promise<ContractResponse> {
  const result = await api.post(BASE_CONTRACTS_API_URL, contract);
  return result.data;
}

async function updateContract(
  contract: ContractResponse
): Promise<ContractResponse> {
  const result = await api.put(
    `${BASE_CONTRACTS_API_URL}/${contract.id}`,
    contract
  );
  return result.data;
}

async function sendContractToSign(
  contractId: number,
  payload: SendContractRequest
): Promise<ContractResponse> {
  const result = await api.post(
    `${BASE_CONTRACTS_API_URL}/${contractId}/send`,
    payload
  );
  return result.data;
}

export default {
  getSignedContracts,
  updateSignedContract,
  uploadSignedContract,
  resendSignedContract,
  deleteSignedContract,
  getContracts,
  getContract,
  getAllContracts,
  createContract,
  updateContract,
  sendContractToSign,
};
